// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Section_bottomLine__1-zGz","Section":"Section_Section__3ScCX","name":"Section_name__1fUN6","main":"Section_main__2z6bi","border":"Section_border__ZwSgf"};